const placementFilters = {
  placementTypeId: null,
  onlyFinalizedContracts: false,
  dealStatusId: null,
  businessEntityId: null,
  clientId: null,
  consultantId: null,
  consultantName: null,
  jobTitle: null
}

export default () => Object.assign({}, placementFilters)
